"use client"

import { useContext, useEffect } from "react"
import { SiteConfigContext } from "@/contexts/site-config"

export const useSiteConfigEffects = () => {
  const { state: siteConfig, dispatch: dispatchConfig } =
    useContext(SiteConfigContext)

  const getPlanDetails = async () => {
    const response = await fetch(`/api/subscriptions/plans/all/CLP`)
    const data = await response.json()
    dispatchConfig({
      type: "SET_PLANS",
      payload: data,
    })
  }
  useEffect(() => {
    getPlanDetails()
  }, [])
}
